import type { Colors, DefaultTheme } from 'styled-components';
import { setAlpha } from '../utils';
import { lightColors, mapLightTheme } from './LightTheme';

const colors: Colors = {
  black: lightColors.black,
  white: lightColors.white,
  gray: lightColors.gray,

  primary: {
    lighten: '#098300',
    default: '#29AC00',
    dim: setAlpha(0.4, '#29AC00'),
    mute: setAlpha(0.1, '#29AC00'),
  },

  green: {
    lighten: '#196700',
    default: '#098300',
    dim: setAlpha(0.4, '#098300'),
    mute: setAlpha(0.1, '#098300'),
  },
  red: {
    lighten: '#6B121B',
    default: '#D11328',
    dim: setAlpha(0.4, '#D11328'),
    mute: setAlpha(0.1, '#D11328'),
  },

  yellow: {
    mute: setAlpha(0.1, '#F8CA2D'),
    dim: setAlpha(0.4, '#F8CA2D'),
    default: '#F8CA2D',
    lighten: '#DAA800',
  },

  blue: {
    default: '#437EFF',
    lighten: '#1954E0',
    dim: setAlpha(0.4, '#437EFF'),
    mute: setAlpha(0.1, '#437EFF'),
  },
  orange: lightColors.orange,
  purple: lightColors.purple,
};

export const LightBitsoTheme: DefaultTheme = mapLightTheme(colors, {
  name: 'LightBso',
  backgroundNegativeButtonActive: colors.red.default,
  backgroundNegativeButtonFocus: colors.red.default,
  backgroundPositiveButtonActive: colors.green.default,
  backgroundPositiveButtonFocus: colors.green.default,
  backgroundPrimaryButtonActive: colors.primary.default,
  backgroundPrimaryButtonFocus: colors.primary.default,

  backgroundChartUpColor: colors.green.default,
  borderColorChartUpColor: colors.green.default,
  backgroundChartDownColor: colors.red.default,
  borderColorChartDownColor: colors.red.default,
});
